import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-arrow-2",
  "use": "icon-arrow-2-usage",
  "viewBox": "0 0 8.69 5.76",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 8.69 5.76\" id=\"icon-arrow-2\"><defs><style>#icon-arrow-2 .cls-1{fill:none;stroke:#0df;stroke-miterlimit:10;stroke-width:2px;}</style></defs><g id=\"icon-arrow-2_圖層_2\" data-name=\"圖層 2\"><g id=\"icon-arrow-2_圖層_1-2\" data-name=\"圖層 1\"><polyline class=\"cls-1\" points=\"0.71 5.05 4.35 1.41 7.99 5.05\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol